import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

/**
 * Card — fundo branco, borda sutil de 1px, sombra quase imperceptível.
 * Substitui o card antigo com `linear-gradient(180deg,#101a30,#0d1526)`.
 */

export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <section
      className={cn('rounded-lg border border-ink-200 bg-white shadow-xs', className)}
    >
      {children}
    </section>
  )
}

export function CardHeader({
  title,
  description,
  actions,
  className,
}: {
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <header
      className={cn(
        'flex items-start justify-between gap-4 border-b border-ink-200 px-4 py-3',
        className,
      )}
    >
      <div className="min-w-0">
        <h2 className="text-base text-ink-800">{title}</h2>
        {description && <p className="mt-0.5 text-xs text-ink-500">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  )
}

export function CardBody({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn('px-4 py-4', className)}>{children}</div>
}

/** Rodapé de ações. Fundo levemente cinza para separar do conteúdo. */
export function CardFooter({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <footer
      className={cn(
        'flex items-center justify-end gap-2 rounded-b-lg border-t border-ink-200 bg-ink-50 px-4 py-3',
        className,
      )}
    >
      {children}
    </footer>
  )
}

/** Par rótulo/valor — usado nas telas de conferência e detalhe. */
export function Field({
  label,
  children,
  mono,
}: {
  label: ReactNode
  children: ReactNode
  mono?: boolean
}) {
  return (
    <div className="min-w-0">
      <dt className="text-2xs font-medium tracking-wide text-ink-500 uppercase">{label}</dt>
      <dd
        className={cn(
          'mt-0.5 truncate text-sm text-ink-800',
          mono && 'font-mono text-xs',
        )}
      >
        {children}
      </dd>
    </div>
  )
}
